// Minimal auto backup service storing data in localStorage
import axios from 'axios';
const BACKUP_KEY = 'tableaux_backup';
const API_BASE_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3001');
let timer = null;

export function startAutoBackup(intervalMinutes = 30) {
  if (timer) return;
  timer = setInterval(
    () => {
      try {
        const data = localStorage.getItem('tableaux');
        if (data) {
          localStorage.setItem(BACKUP_KEY, data);
          console.log('✅ Backup saved');
        }
      } catch (err) {
        console.error('Backup error', err);
      }
    },
    intervalMinutes * 60 * 1000
  );
}

export function stopAutoBackup() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

export async function exportBackup(token) {
  const res = await axios.get(`${API_BASE_URL}/api/backup`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
}

export async function importBackup(data, token) {
  await axios.post(`${API_BASE_URL}/api/backup`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export default { startAutoBackup, stopAutoBackup, exportBackup, importBackup };
